import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { SectionHead } from "../components/Reveal";
import { INDUSTRIES } from "../data/content";
import { INDUSTRY_IMGS } from "../data/images";

export default function Industries() {
  return (
    <main className="pt-28">
      <section data-testid="industries-section" className="section-pad !pt-8">
        <div className="container-x">
          <SectionHead badge="Industries" title="Industries We Serve"
            sub="Deep domain context across sixteen sectors — so we speak your language from the first call." />
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
            {INDUSTRIES.map((ind, i) => {
              const Icon = Icons[ind.icon] || Icons.Sparkles;
              return (
                <motion.div key={ind.name} data-testid={`industry-card-${ind.name.toLowerCase().replace(/\s+/g, "-")}`}
                  initial={{ opacity: 0, y: 26 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.45, delay: (i % 4) * 0.07 }} whileHover={{ y: -6, scale: 1.02 }}
                  className="glass-card rounded-2xl overflow-hidden">
                  <img src={INDUSTRY_IMGS[ind.name]} alt={`${ind.name} industry solutions`}
                    className="w-full h-28 object-cover" />
                  <div className="p-5">
                  <span className="w-12 h-12 rounded-xl bg-gradient-to-br from-indigo-500/15 to-cyan-400/15 border border-primary/20 text-primary flex items-center justify-center">
                    <Icon size={22} />
                  </span>
                  <h3 className="mt-4 font-semibold">{ind.name}</h3>
                  <p className="mt-1.5 text-xs sm:text-sm text-muted-foreground leading-relaxed">{ind.desc}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
}
